import { render, staticRenderFns } from "./GnbDownMenu.vue?vue&type=template&id=95e53914&scoped=true&"
import script from "./GnbDownMenu.vue?vue&type=script&lang=js&"
export * from "./GnbDownMenu.vue?vue&type=script&lang=js&"
import style0 from "./GnbDownMenu.vue?vue&type=style&index=0&id=95e53914&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e53914",
  null
  
)

export default component.exports